export default __webpack_public_path__ + "193e7e2d3438d8697ce6e117b56a8bd9.png";